module.exports = __webpack_public_path__ + "static/media/ad.7bb20e6a.svg";